/**
 * 特殊动作：窗口显示
 */
import fvAnimation from "./fvAnimation"
export default class fvWindowOpen extends fvAnimation {
    constructor(shape){
        super(shape,"fvWindowOpen");
    }

    run(event,value){
        //if(value == false) return;
        if(this.shape.mouseState == 1 && event.button == 0 && this.getEventType(event.type) == 'down'){
            this.executionScript("this.Display("+this.windowOpen +")");
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvWindowOpen.js